export enum TabsMenuOptionsRoutes {
  Dados = "dados",
  Cotacoes = "cotacoes",
}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permission?: string;
}[] = [
  {
    label: "Dados",
    route: TabsMenuOptionsRoutes.Dados,
  },
  {
    label: "Cotações",
    route: TabsMenuOptionsRoutes.Cotacoes,
  },
];
